module.exports = "<button mat-icon-button (click)=\"onDrawerToggle()\">\n  <mat-icon aria-label=\"button to open drawer menu\" *ngIf=\"!isDisplay\">menu</mat-icon>\n  <mat-icon aria-label=\"button to close drawer menu\" *ngIf=\"isDisplay\">arrow_back</mat-icon>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/drawer/drawer-toggle/drawer-toggle.component.html
// module id = ../../../../../src/app/layout/drawer/drawer-toggle/drawer-toggle.component.html
// module chunks = main